
const api_path = 'https://api-gateway-dev.zevo-tech.com/GatewayAPI';
export default api_path;